// src/components/BookingList.jsx
import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import InstallmentModal from "../accountsPages/InstallmentModal";
import { Button } from "react-bootstrap";
import Footer from "../../components/Footer";
import { useNavigate } from "react-router-dom";

export default function BookingList({ user, onLogout }) {
  //  Get current logged in user
  user = JSON.parse(localStorage.getItem("user")) || {};

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  async function fetchBookings() {
    setLoading(true);
    try {
      // Adjust query according to your backend (include user and payments)
      const res = await api.get(
        "/api/booking-installment?with=user,property,unit,payments"
      );
      console.log("bookings", res);
      setBookings(res.data.data || res.data);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchBookings();
  }, []);

  function openModal(booking) {
    console.log("open modal", booking);
    setSelectedBooking(booking);
    console.log("selectBooking", selectedBooking);
    setShowModal(true);
  }

  function closeModal() {
    setSelectedBooking(null);
    setShowModal(false);
  }

  async function downloadInstallmentReport(bookingId) {
    try {
      const res = await api.get(`/api/installments/report/${bookingId}`, {
        responseType: "blob",
      });
      // create file link
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `installments_report_booking_${bookingId}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e) {
      if (e.response && e.response.data) {
        e.response.data.text().then((text) => console.log(text)); // Laravel error message
      }
      console.log("error", e);
      alert("Unable to download PDF.");
    }
  }

  async function downloadDownPaymentReceipt(booking) {
    const receipt = booking.invoices?.[0];
    if (!receipt?.id) return;

    try {
      const res = await api.get(`/api/invoices/${receipt.id}/pdf`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Receipt-${receipt.invoice_number || receipt.id}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.log("error", e);
      alert("Unable to download receipt.");
    }
  }

  return (
    <>
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h2
            className="text-center mb-4 text-primary fw-bold"
            style={{ textDecoration: "underline", color: "blue" }}
          >
            Bookings (Installment)
          </h2>
          <Button variant="outline-secondary" size="sm" onClick={fetchBookings}>
            Refresh
          </Button>
        </div>

        {loading ? (
          <div>Loading...</div>
        ) : bookings.length > 0 ? (
          <div className="table-responsive shadow-sm rounded">
            <table className="table table-hover table-bordered mb-0">
              <thead className="table-primary">
                <tr>
                  <th>#</th>
                  <th>Customer</th>
                  <th>Property</th>
                  <th>Unit</th>
                  <th>Total</th>
                  <th>Paid</th>
                  <th>Due</th>
                  <th>Check In</th>
                  <th>Check Out</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {bookings.map((b, idx) => {
                  const hasInstallments =
                    Array.isArray(b.installments) && b.installments.length > 0;
                  const downPaymentReceipt = b.invoices?.[0];
                  console.log("b", b);
                  return (
                    <tr key={b.id}>
                      <td>{idx + 1}</td>
                      <td>{b.user?.name || b.payer_name || "—"}</td>
                      <td>{b.property?.name || "—"}</td>
                      <td>{b.unit?.unit_number || b.unit?.name || "—"}</td>
                      <td>{Number(b.total_amount).toFixed(2)}</td>
                      <td>
                        {" "}
                        {b.payments
                          ?.filter((p) => p.payment_status === "success")
                          ?.reduce((sum, p) => sum + Number(p.amount), 0)
                          .toFixed(2)}
                      </td>
                      <td
                        className={
                          b.due_amount > 0
                            ? "text-danger fw-bold"
                            : "text-success"
                        }
                      >
                        {Number(b.due_amount).toFixed(2)}
                      </td>
                      <td>{b.check_in_date || "—"}</td>
                      <td>{b.check_out_date || "—"}</td>
                      <td className="text-nowrap">
                        <Button
                          size="sm"
                          variant="primary"
                          className="me-2"
                          onClick={() => openModal(b)}
                        >
                          {hasInstallments ? "Edit Installment" : "Installment"}
                        </Button>

                        <Button
                          size="sm"
                          variant="outline-success"
                          className="me-2"
                          onClick={() => downloadInstallmentReport(b.id)}
                        >
                          PDF
                        </Button>

                        {/* Payment history of the booking; staff can request a refund there. */}
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          className="me-2"
                          onClick={() => navigate(`/properties_booked/${b.id}`)}
                        >
                          Payments
                        </Button>

                        {downPaymentReceipt && (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => downloadDownPaymentReceipt(b)}
                          >
                            Receipt
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div
            className="alert alert-danger text-center  "
            style={{ fontSize: "1.5rem" }}
          >
            No bookings found.
          </div>
        )}

        {selectedBooking && (
          <InstallmentModal
            show={showModal}
            onHide={closeModal}
            booking={selectedBooking}
            refreshList={fetchBookings}
          />
        )}
      </div>
    </>
  );
}
